import React from 'react'
import MatchCVPage from '../parts/pages/MatchCVPage'

export default function MatchCV() {
  return <MatchCVPage />
}
